import IndexPage from '@dex/bubl-dash/src/lib/pages/IndexPage';
import FormEntryCreateEditForm from './Components/FormEntryCreateEditForm';
import FormEntryApi from './FormEntryApi';

export default function (app, settings) {

    app.addRoute({
        name: settings.key + "New",
        zone: settings.zone,
        path: settings.key + "/create",
        caps: settings.createCaps,
        component: IndexPage,
        componentProps: {
            header: {
                getTitle: () => "Add New",
                getButtons: settings.indexButtons,
                getTabs: settings.indexTabs,
                getTabCounts: settings.indexTabCounts,
            },
            create: {
                form: FormEntryCreateEditForm,
                getCreate: FormEntryApi.create,
                defaults: {},
                successMessage: "FormEntry Saved",
                successRouteName: settings.key + "View",
                idKey: settings.idKey
            }
        },
    });

}